export default [
  {
    path: '/guide',
    component: () => import('@/views/guide/guide.vue'),
    name: 'guide',
    meta: {
      title: '息屏导航引导',
      backgroundClass: 'bg-black',
    },
  },
  {
    path: '/guide-nfcGuide',
    component: () => import('@/views/guide/NfcGuide.vue'),
    name: 'nfcGuide',
    meta: {
      title: 'NFC 钥匙管理',
      backgroundClass: 'bg-black',
    },
  },
];
